<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="6" lg="4">
        <v-card class="text-center pa-8" elevation="2">
          <div v-if="!error">
            <!-- Loading state -->
            <v-progress-circular
              :size="80"
              :width="6"
              color="primary"
              indeterminate
              class="mb-6"
            ></v-progress-circular>

            <h2 class="mb-4">{{ $t('qr.redirect-to-stripe') }}</h2>
            <p class="text-body-2 grey--text">
              {{ $t('qr.please-wait-redirect') }}
            </p>
          </div>

          <div v-else>
            <!-- Error state -->
            <v-icon size="80" color="error" class="mb-6">
              mdi-alert-circle-outline
            </v-icon>

            <h2 class="mb-4 error--text">{{ $t('qr.redirect-error') }}</h2>
            <p class="text-body-2 mb-6">{{ error }}</p>

            <v-btn
              color="primary"
              @click="retry"
              :loading="loading"
            >
              <v-icon left>mdi-refresh</v-icon>
              {{ $t('qr.retry') }}
            </v-btn>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import PayoutRepository from '@repository/PayoutRepository'

export default {
  name: 'PaymentOnboardingRelay',

  data() {
    return {
      loading: false,
      error: null
    }
  },

  computed: {
    organizationId() {
      return this.$route.params.id
    }
  },

  mounted() {
    this.redirectToOnboarding()
  },

  methods: {
    async redirectToOnboarding() {
      if (!this.organizationId) {
        this.error = this.$t('qr.organization-not-found')
        return
      }

      this.loading = true
      this.error = null

      try {
        // Step 1: Create or fetch beneficiary
        const beneficiaryResult = await PayoutRepository.createBeneficiary({
          ownerType: 'organization',
          ownerId: this.organizationId
        })

        const beneficiary = beneficiaryResult?.beneficiary || beneficiaryResult

        if (!beneficiary?.beneficiaryId) {
          throw new Error(this.$t('qr.beneficiary-not-found'))
        }

        // Step 2: Create onboarding link with return URL
        const returnUrl = window.location.origin + `/organizations/${this.organizationId}/payment-methods/payout`

        const linkResult = await PayoutRepository.createOnboardingLink(
          beneficiary.beneficiaryId,
          false, // hosted mode (not embedded)
          returnUrl
        )

        const stripeUrl = linkResult?.url

        if (!stripeUrl) {
          throw new Error(this.$t('qr.stripe-link-not-generated'))
        }

        // Step 3: Redirect to Stripe
        window.location.href = stripeUrl

      } catch (e) {
        this.error = e?.response?.data?.message || e?.message || this.$t('qr.unknown-error')
        this.loading = false
      }
    },

    retry() {
      this.redirectToOnboarding()
    }
  }
}
</script>

<style scoped>
.fill-height {
  min-height: 100vh;
}
</style>
